import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "tamr-icon-check-inverted",
  "use": "tamr-icon-check-inverted-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"tamr-icon-check-inverted\"><path d=\"M16,0A16,16,0,1,0,32,16,16,16,0,0,0,16,0Zm8.7,11.7-11,10L13,22H12.9a1,1,0,0,1-.7-0.4l-5-6a1,1,0,1,1,1.5-1.3l4.3,5.2,10.2-9.3A1,1,0,1,1,24.7,11.7Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol